export default __webpack_public_path__ + "static/media/Landing_Logo_IEIM.dc5ec459.png";